export default __webpack_public_path__ + "static/media/jira.4b6351e5.svg";